import React, { useCallback, useEffect, useState } from "react";

import type { SolverSettingsModalProps } from "@/components/modals/SolverSettingsModal.types.ts";
import type { DepartmentConfigs, Schedule, SolverBaseOptions, SolverBlockLogicOptions, SolverConfigs, SolverConstructionHeuristicOptions, SolverMandatoryEntityOptions, SolverPhase } from "@/types.ts";
import type { SolverSettingOptionsController, SolverSettingsOptionsProps } from "@/components/sections/SolverSettingsOptions.types.tsx";
import type { SolverPhasesController, SolverPhasesProps } from "@/components/sections/SolverPhases.types.tsx";
import { PlusCircle, Settings, ChevronRight,Tags} from "lucide-react";
import type { SolverPhaseConfigController, SolverPhaseConfigProps } from "@/components/sections/SolverPhaseConfig.types.tsx";
import Input from "@/components/forms/Input.tsx";
import SolverSettingsModal from "@/components/modals/SolverSettingsModal.tsx";
import type { SolverPhaseNeedsController, SolverPhaseNeedsProps } from "@/components/sections/SolverPhaseNeeds.types.tsx";
import RoleDayGrid from "@/components/sections/RoleDayGrid";
import { createRoleDayUIItem, createRoleHeaderDayUIItem } from "@/utils/roleDayGridUtils";

// function safeParseInputTimeSecondsToMilli(seconds:string):number{
//     const parseSeconds = parseFloat(seconds||"0");
//     if(isNaN(parseSeconds))return 0;
//     return Math.floor(parseSeconds * 1000);
// }

// function safeParseInputIntNumber(seconds:string):number{
//     const parseSeconds = parseFloat(seconds||"0");
//     if(isNaN(parseSeconds))return 0;
//     return Math.floor(parseSeconds);
// }

// function initOptionNumber(value:number | undefined | null, defaultInitValue:number):number{
//     if(value === void 0  || value ===null)return defaultInitValue;
//     return value
// }




const InputGroupWrapper: React.FC<{children: React.ReactNode , onClick? : ()=>void}> = (props)=>{
    return <div 
        onClick={props.onClick}
        className={`p-4 border-1 border-gray-300 rounded-sm my-2` + (props.onClick ? ' cursor-pointer' : '')}>
        {props.children}
    </div>
}


const RadioButton: React.FC<{
    checked: boolean,
    onChange:React.ChangeEventHandler<HTMLInputElement, HTMLInputElement> | undefined
}> = (props)=>{
    return <input
        type="radio"
        checked={props.checked}
        disabled={false}
        onChange={props.onChange}
        className="h-4 w-4 accent-blue-600"
    />
}


const PhaseInner: React.FC<{
    title : string,
    checked: boolean,
    onChange:React.ChangeEventHandler<HTMLInputElement, HTMLInputElement> | undefined
    //children: React.ReactNode
}> = (props)=>{
    return <div className="flex items-center gap-2">
        <RadioButton
            checked={props.checked}
            onChange={props.onChange}
        />
        <span className={`text-sm`}>{props.title}</span>
    </div>
}



export function buildSolverPhaseNeedsController(
    phase  : SolverPhase | undefined,
    phaseId:string | undefined,
    schedule: Schedule | null
) : SolverPhaseNeedsController{

    const [editData , setEditData] = useState({...{},...phase});
    const editMapOfNeedSettings = editData.mapOfNeedSettings ||{};
   // const daysOrder = ["0" , ""]
    var listOfUINeeds:SolverPhaseNeedsController["viewData"]["listOfUINeeds"] = [];
    var header:SolverPhaseNeedsController["viewData"]["header"] = {days:[
        createRoleHeaderDayUIItem("0"),
        createRoleHeaderDayUIItem("1"),
        createRoleHeaderDayUIItem("2"),
        createRoleHeaderDayUIItem("3"),
        createRoleHeaderDayUIItem("4"),
        createRoleHeaderDayUIItem("5"),
        createRoleHeaderDayUIItem("6"),
    ]};
    //var entries =Object.entries(editData.mapOfNeedSettings || {});


    schedule?.roles?.forEach((role)=>{
        var editDaysValues = (editMapOfNeedSettings[role.id]||{}).mapOfDayOptions ||{};
        var item = {
            name :  role.name,
            id :  role.id,
            days : [
                createRoleDayUIItem("0", editDaysValues ),
                createRoleDayUIItem("1", editDaysValues ),
                createRoleDayUIItem("2", editDaysValues ),
                createRoleDayUIItem("3", editDaysValues ),
                createRoleDayUIItem("4", editDaysValues ),
                createRoleDayUIItem("5", editDaysValues ),
                createRoleDayUIItem("6", editDaysValues ),
            ],
            isAll: false
        }

        item.isAll = item.days[0]!.value 
            && item.days[1]!.value 
            && item.days[2]!.value 
            && item.days[3]!.value 
            && item.days[4]!.value 
            && item.days[5]!.value 
            && item.days[6]!.value ;


        listOfUINeeds.push(item);


        

    });

  //  var listOfUINeeds:SolverPhasesController["viewData"]["listOfUIPhases"] = [];

    // for (const [key, value] of entries) {
    //     if(value && value.active !== false){
    //         listOfUINeeds.push({
    //             name : value.name || "-",
    //             id : key,
    //             phase : value
    //         });
    //     }
    // }


    const viewData:SolverPhaseNeedsController["viewData"] = {
        phaseId : phaseId,
        phase : phase,
        isNew : !(!!phase && !!phaseId),
        listOfUINeeds:listOfUINeeds,
        header
    }


    return {
        setEditData,
        editData,
        viewData,

    }
}


/**
 * Main component
 * @param param0
 * @returns 
 */
const SolverPhaseNeeds: React.FC<SolverPhaseNeedsProps> = (props) => {

    //const [editData , setEditData] = useState({...{},...solverConfigs});
    //const [confirmOpenPhaseSettingModal, setConfirmOpenPhaseSettingModal] = useState(false);
    const ctrl =props.controller;
    const setEditData = ctrl.setEditData;
    const editData = ctrl.editData;
    const viewData = ctrl.viewData;
    // const selectSolverConfig =  (()=>{
    //     setConfirmOpenPhaseSettingModal(true)
    // });
   // ctrl.viewData.
    //const LABEL_SOLVER_PARAMS ="Paramètres du solveur";
    return (
         <div className="text-gray-700">

                <RoleDayGrid
                    headerDays={viewData.header.days}
                    listOfUINeeds={viewData.listOfUINeeds}
                    onRoleDayClick={props.onRoleDayClick}
                    onRoleAllDaysClick={props.onRoleAllDaysClick}
                />
                {/* <InputGroupWrapper onClick={()=>{}}>
                    <div className="flex items-center gap-2">
                        <Tags />
                        <span className={`text-sm`}>{'Besoins'}</span>
                        <div className="ml-auto"> <ChevronRight /></div>
                    </div>
                </InputGroupWrapper> */}
         </div>
    );
};

export default SolverPhaseNeeds;
